import React from "react";

import { useLocation, Navigate } from "react-router-dom";

import useDecodedParams from "Hooks/useDecodedParams";
import useSelectorWithUrlParams from "Hooks/useSelectorWithUrlParams";
import useUrls from "Hooks/useUrls";
import { environmentErrorSelector } from "Reducers/environment";

type NoEnvironmentRedirectProps = {
  children: React.ReactNode;
};
export const NoEnvironmentRedirect = ({
  children
}: NoEnvironmentRedirectProps) => {
  const location = useLocation();
  const { environmentId } = useDecodedParams<{
    projectId: string;
    organizationId: string;
    environmentId?: string;
  }>();

  const environmentError = useSelectorWithUrlParams(environmentErrorSelector);

  const [projectOverviewUrl] = useUrls(["organization.project"], {
    environmentId: environmentId ?? ""
  });

  if (environmentError && location.pathname !== projectOverviewUrl) {
    return <Navigate to={projectOverviewUrl} />;
  }

  return children;
};
